import { useEffect } from 'react';

/**
 * Mirrors the active brand onto `<html>` so the page canvas can be painted.
 *
 * The brand tokens are defined by `[data-brand]` in `tokens.css`, and that
 * attribute lives on `.app-root` — which means `html` and `body` sit *outside*
 * the scope that defines `--brand-bg` and can never read it. Nothing then
 * paints the canvas, so any strip of the document the app's own box does not
 * cover is left as the browser's default white. `html`, `body` and `#root` are
 * all `height: 100%` while `.app-root` is `min-height: 100vh`; those two agree
 * in the ideal case but round apart at fractional zoom and device pixel
 * ratios, and the gap shows up as a white line along the bottom of the page.
 *
 * Custom properties inherit, so putting `data-brand` on the document element
 * hands the brand contract to the whole document, canvas included. The
 * attribute stays on `.app-root` as well: that is what dresses the app on the
 * very first paint, before this effect has run, so a direct load of a branded
 * route never flashes another brand's colours through the body of the page.
 */
export const useBrandCanvas = (brand: string): void => {
  useEffect(() => {
    document.documentElement.dataset.brand = brand;
  }, [brand]);
};
